module.exports = __webpack_public_path__ + "img/fla.1d522c9e.png";